import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/search/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/search/';

const SIZE_PLAYERS_STAT = 99999;
class SearchService {

  getUserSearches() {
    return axios.get(API_URL);
  }

  getSearchById(searchId) {
    return axios.get(`${API_URL}${searchId}`);
  }

  getUserSimilaritySearches() {
    return axios.get(`${API_URL}similarity`);
  }

  getSimilaritySearchById(searchId) {
    return axios.get(`${API_URL}similarity/${searchId}`);
  }

  saveSearch(search){
    search.filtersValue = JSON.stringify({filters:search.filters, headers:search.headers, templateId:search.templateId});
    return axios.post(`${API_URL}`,search);
  }

  saveSimilaritySearch(search){
    search.filtersValue = encodeURIComponent(JSON.stringify(search));
    return axios.post(`${API_URL}similarity`,search);
  }

  deleteSearch(searchId) {
    return axios.delete(`${API_URL}${searchId}`);
  }

  updateSearch(searchId, search) {
    search.filtersValue = JSON.stringify({filters: search.filters, headers: search.headers, templateId: search.templateId});
    return axios.put(`${API_URL}${searchId}`, search);
  }

  getGlobalDataSet(leagueYearOffset = 1) {
    return axios.get(API_URL + 'global/' + leagueYearOffset);
  }

  getGlobalPlayersDataSet(leagueYearOffset = 1) {
    return axios.get(API_URL + 'global/players/' + leagueYearOffset);
  }

  getGlobalGamesDataSet(leagueYearOffset = 1) {
    return axios.get(API_URL + 'global/games/' + leagueYearOffset);
  }

  getPlayersDataSet(query,size = 3,leagueYearOffset = 1) {
    return axios.get(API_URL + 'players/' + leagueYearOffset,{params:{query,size}});
  }

  getAllStats(playerScoutData, page=0, size=SIZE_PLAYERS_STAT, sort='', fromFavorites = false, onlySelf = false){
      return axios.post(`${API_URL}all-player-stats/search-players/`, playerScoutData, { headers: authHeader(),params:{page, size, sort, fromFavorites, onlySelf}});
  }

  getComparisonPlayerStats(playersId,years,accumulation,page=0,size=SIZE_PLAYERS_STAT,sort=''){
      return axios.get(`${API_URL}comparison-player-stats/${playersId}`+
      `/year/${years}/accumulation/${accumulation}`
        , { headers: authHeader(),params:{page,size,sort}});

  }

  getComparisonPlayerStatsBySeason(playersId,seasonsId,accumulation,page=0,size=SIZE_PLAYERS_STAT,sort=''){
    return axios.get(`${API_URL}comparison-player-stats/${playersId}`+
    `/season/${seasonsId}/accumulation/${accumulation}`
      , { headers: authHeader(),params:{page,size,sort}});
}

  saveSearchAlert(userId,userFilterId){
    return axios.post(`${API_URL}save-player-search-alert`, {userId,userFilterId});
  }

  deleteSearchAlert(userId,userFilterId){
    return axios.post(`${API_URL}delete-player-search-alert`, {userId,userFilterId});
  }

  saveSearchNotifications(userId,userFilterId){
    return axios.post(`${API_URL}save-player-search-notifications`, {userId, userFilterId});
  }

  deleteSearchNotifications(userId,userFilterId){
    return axios.post(`${API_URL}delete-player-search-notifications`, {userId, userFilterId});
  }


    savePlayerAlert(userId, alertId){
      return axios.post(`${API_URL}save-player-alert`, {userId,alertId});
    }

    deletePlayerAlert(userId, alertId){
      return axios.post(`${API_URL}delete-player-alert`, {userId,alertId});
    }

  savePlayerNotifications(userId, alertId){
    return axios.post(`${API_URL}save-player-notifications`, {userId,alertId});
  }

  deletePlayerNotifications(userId, alertId){
    return axios.post(`${API_URL}delete-player-notifications`, {userId,alertId});
  }

}

export default new SearchService();
